import { Box, Card, CardContent, CardHeader } from '@mui/material';
import { CardSearch } from "@arelia-components/ui-atoms/CardSearch";
import { TwilioRegistrationRecordList } from './components/TwilioRegistrationRecordList';
import { TwilioSessionsList } from './components/TwilioSessionsList';
import { TwilioRegistrationRecord } from './models';
import SpinnerWrapper from '@arelia-components/ui-atoms/SpinnerWrapper';

type Props = {
  searchValue: string;
  setSearchValue: (value: string) => void;
  records?: TwilioRegistrationRecord[];
  sessions?: TwilioRegistrationRecord[];
  isLoadingRecords: boolean;
  isLoadingSessions: boolean;
}

export function TwilioMonitorPresenter({
  searchValue,
  setSearchValue,
  records: twilioRegistrationRecords = [],
  sessions = [],
  isLoadingRecords,
  isLoadingSessions
}: Props) {
  return (
    <Box sx={styles.listBox}>
      <Card sx={styles.listCard}>
        <CardHeader
          title="Twilio Registration Records"
          sx={styles.listCardHeader}
          action={<CardSearch value={searchValue} onChange={setSearchValue} />}
        />
        <CardContent sx={styles.cardContent}>
          <SpinnerWrapper loading={isLoadingRecords}>
          <TwilioRegistrationRecordList twilioRegistrationRecords={twilioRegistrationRecords} />  
          </SpinnerWrapper>
        </CardContent>
      </Card>
      <Card sx={styles.detailsBox}>
        <CardHeader
          title="Active Sessions"
          sx={styles.listCardHeader}
        />
        <CardContent sx={styles.cardContent}>
          <Box sx={styles.contentBox}>
            <TwilioSessionsList
              sessions={sessions}
              isLoading={isLoadingSessions}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

const styles = {
  listBox: {
    display: "flex",
    gap: "22px",
    alignItems: "flex-start"
  },
  listCard: {
    flex: 1
  },
  listCardHeader: {
    marginBottom: "32px"
  },
  cardContent: {
    height: "460px",
    overflow: "auto"
  },
  contentBox: {
    height: "100%"
  },
  detailsBox: {
    width: "356px",
    position: "sticky",
    top: 0
  }
};
